/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropType from 'prop-types';

import TextField from '@mui/material/TextField';
import './NInputs.css';

function NInput(props) {
  const { className, label, placeholder, type } = props;

  return (
    <div className='App-inputs input-textfield'>
      <TextField
        className={className}
        placeholder={placeholder}
        label={label}
        type={type}
        {...props}
      />
    </div>
  );
}

NInput.propTypes = {
  label: PropType.string,
  placeholder: PropType.string,
  type: PropType.string,
  className: PropType.string,
  iconstart: PropType.element,
  iconend: PropType.element,
};

NInput.defaultProps = {
  className: '',
  label: '',
  type: 'text',
  placeholder: 'Placeholder',
  iconstart: undefined,
  iconend: undefined,
};

export default NInput;
